import PropTypes from 'prop-types';
import React from 'react';
import Tag from '../../../../../../Elements/Tag/Tag';

import './TagList.scss';

export default class TagList extends React.PureComponent {
    static propTypes = {
        /**
         * styling for Tag component
         */
        tagClassName: PropTypes.string.isRequired,
        /**
         * list of tag names
         */
        tagNames: PropTypes.array.isRequired,
    };

    static defaultProps = {
        tagClassName: '',
        tagNames: [],
    };

    render() {
        const { tagNames, tagClassName, children } = this.props;

        return (
            <div className="component-Groups-Search-SearchPageSection-GroupSearchResults-TagList">
                {tagNames.map((tagName, index) => (
                    <Tag
                        key={`${tagName}-${index}`}
                        shouldAllowDelete={false}
                        tagCssClass={`${tagClassName}`}
                    >
                        {tagName}
                    </Tag>
                ))}
                {children}
            </div>
        );
    }
}
